import { lazy } from 'react';
import { withProvider } from '@/hook/withProvider.jsx';
import { ProgramProvider } from '@/context/ProgramContext.jsx';

const OverviewPage = lazy(() => import('@pages/daycare/OverviewPage.jsx'));
const NewsPage = lazy(() => import('@/pages/daycare/news/NewsPage.jsx'));
const NewsDetailPage = lazy(() =>
  import('@/pages/daycare/news/NewsDetailPage.jsx')
);
const NoticePage = withProvider(
  ProgramProvider,
  lazy(() => import('@pages/daycare/notice/NoticePage.jsx'))
);
const NoticeDetailPage = lazy(() =>
  import('@pages/daycare/notice/NoticeDetailPage.jsx')
);
const NoticeEditPage = lazy(() =>
  import('@pages/daycare/notice/NoticeEditPage.jsx')
);
const IntroductionPage = lazy(() =>
  import('@pages/daycare/IntroductionPage.jsx')
);
const NewsEditPage = lazy(() => import('@pages/daycare/news/NewsEditPage.jsx'));
const ProgramsPage = lazy(() =>
  import('@pages/daycare/programs/SchedulePage.jsx')
);
const ProgramEditPage = lazy(() =>
  import('@pages/daycare/programs/ScheduleEditPage.jsx')
);
const ProgramDetailPage = lazy(() =>
  import('@pages/daycare/programs/ScheduleDetailPage.jsx')
);

const daycareRouter = () => {
  return [
    { path: 'overview', element: <OverviewPage /> },
    { path: 'introduction', element: <IntroductionPage /> },
    { path: 'news', element: <NewsPage /> },
    { path: 'news/create', element: <NewsEditPage /> },
    { path: 'news/edit/:id', element: <NewsEditPage /> },
    { path: 'news/:id', element: <NewsDetailPage /> },
    { path: 'notice', element: <NoticePage /> },
    { path: 'notice/create', element: <NoticeEditPage /> },
    { path: 'notice/edit/:id', element: <NoticeEditPage /> },
    { path: 'notice/:id', element: <NoticeDetailPage /> },
    {
      path: 'programs',
      element: <ProgramsPage />,
    },
    {
      path: 'programs/create',
      element: <ProgramEditPage />,
    },
    {
      path: 'programs/edit/:id',
      element: <ProgramEditPage />,
    },
    {
      path: 'programs/:id',
      element: <ProgramDetailPage />,
    },
  ];
};

export default daycareRouter;
